export default {
    estateSession: {
        estatePlanningSession: 'Estate Planning Session',
        estatePlanningSessionDescription:
            'A private video call with one of our Will specialists to help you organise your wishes and plan your estate. This session does not include a Will — it can be taken as a standalone first step to get guidance, or used alongside one of our Will products. If you decide to proceed with our premium service, this session fee will be deducted from the total amount.',

        estatePlanningSessionIdealFor1: 'Clients wanting additional guidance and support',
        estatePlanningSessionIdealFor2: 'Overseas assets including tax considerations',
        estatePlanningSessionIncludes1: 'Discussion of Executors, Guardians, and distributions;',
        estatePlanningSessionIncludes2: 'Review of your asset list and estate planning details;',
        estatePlanningSessionIncludes3: 'Guidance for your overseas assets',
        estatePlanningSessionIncludes4: 'Minor adjustments to your Will',
        estatePlanningSessionIncludes5: '30-minute private video call with a Will specialist',
        productSub: 'For first-time clients',
        productSub2: 'For returning clients',
    },
};
